import {Linking} from 'react-native';

/**
 * Project contact shown in the app (About page, Research data sharing screen).
 * An EPFL group alias that forwards to the project team, so it stays valid
 * when individual members change. Also referenced in consent documents:
 * change both together.
 */
export const FEEDBACK_EMAIL = 'adaptmh-feedback@groupes.epfl.ch';

export const openFeedbackEmail = (subject?: string): Promise<void> => {
  const query = subject ? `?subject=${encodeURIComponent(subject)}` : '';
  return Linking.openURL(`mailto:${FEEDBACK_EMAIL}${query}`).catch(() => undefined);
};
